import { FileText, Video, Upload, ClipboardCheck } from 'lucide-react';
import type { LessonType } from '@/types';

export const LESSON_TYPE_ICONS: Record<LessonType, typeof FileText> = {
  content: FileText,
  document_reading: FileText,
  video: Video,
  presentation: FileText,
  evidence_upload: Upload,
  practical_record: ClipboardCheck,
  practical_observation: ClipboardCheck,
};

export const LESSON_TYPE_LABELS: Record<LessonType, string> = {
  content: 'Contenido',
  document_reading: 'Lectura de documento',
  video: 'Video',
  presentation: 'Presentación',
  evidence_upload: 'Subir evidencia',
  practical_record: 'Registro práctico',
  practical_observation: 'Observación práctica',
};
